import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c5373aea"
import script from "./App.vue?vue&type=script&defer=true&lang=js"
export * from "./App.vue?vue&type=script&defer=true&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=c5373aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports